module.exports = __webpack_public_path__ + "static/media/device-icon.a325df11.svg";